import { useListRootPagesQuery } from '@/queries/rootPages.queries';
import linkGroupService from '@/services/linkGroup.service';
import IRootPage from '@/types/IRootPage';
import IRootPageLink from '@/types/IRootPageLink';
import { FormControl, FormErrorMessage, FormLabel, Input, TabPanel } from '@chakra-ui/react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';

interface IAddLinkGroupTabProps {
	form: UseFormReturn<IRootPageLink>;
	rootPage: IRootPage | null;
	setRootPage: (rootPage: IRootPage | null) => void;
}

export default function AddLinkGroupTab(props: IAddLinkGroupTabProps) {
	const { t } = useTranslation();
	const listRootPagesQuery = useListRootPagesQuery();
	const rootPages = listRootPagesQuery.data || [];

	return (
		<TabPanel>
			<FormControl isInvalid={!!props.form.formState.errors.link} my="4">
				<FormLabel>{t('Link group')}</FormLabel>

				<Select
					getOptionLabel={(op) => op.name}
					getOptionValue={(op) => op.name}
					placeholder={t('Select a link group')}
					isClearable
					value={props.rootPage}
					onChange={(v) => {
						if (!v) {
							props.setRootPage(null);
							props.form.setValue('link', '', { shouldValidate: true });
							props.form.setValue('name', '', { shouldValidate: true });
							props.form.setValue('description', '', { shouldValidate: true });
							return;
						}

						const linkGroup = rootPages.find((e) => v.id === e.id);

						if (!linkGroup) {
							return;
						}

						props.setRootPage(linkGroup);
						props.form.setValue('link', linkGroupService.getLink(linkGroup.slug), {
							shouldValidate: true,
						});
						props.form.setValue('name', linkGroup?.name, {
							shouldValidate: true,
						});
						props.form.setValue('description', linkGroup?.description, {
							shouldValidate: true,
						});
					}}
					menuPosition="fixed"
					options={rootPages.map((e) => ({ ...e, label: e.name, value: e.name })) || []}
				/>

				<FormErrorMessage>{props.form.formState.errors.link?.message}</FormErrorMessage>
			</FormControl>

			<FormControl mt="3">
				<Input
					readOnly
					disabled
					value={props.form.watch('link')}
					type="hidden"
					variant="filled"
					placeholder={t('This field will be automatically filled when you select a service')}
				/>
			</FormControl>

			<FormControl mt="3">
				<FormLabel>{t('Visible text')}</FormLabel>
				<Input
					{...props.form.register('name')}
					type="text"
					variant="filled"
					placeholder={t('Write a visible text for your link here')}
				/>
			</FormControl>

			<FormControl mt="3">
				<FormLabel>{t('Description')}</FormLabel>
				<Input
					{...props.form.register('description')}
					variant="filled"
					placeholder={t('Write a description for your link here')}
				/>
			</FormControl>
		</TabPanel>
	);
}
